import React, {useCallback} from 'react';

import _ from 'utils/i18n';

import Select from 'scripts/components/Select';
import Option from 'scripts/components/Option';

const EmptyLabel = _('Please choose…');
const EmptyValue = '-';

const Dropdown = ({id, config: {choices}, answer, updateAnswer}) => {
    const value = (answer && answer.choices && answer.choices.length) ? answer.choices[0] : null;
    const handleChange = useCallback(({target}) => updateAnswer({choices: [target.value]}), [updateAnswer]);

    return (
        <Select id={id} value={value} onChange={handleChange}>
            <Option value={EmptyValue} disabled>{EmptyLabel}</Option>
            {choices && choices.map(({choice}, index) => (
                <Option key={index} value={index}>
                    {choice}
                </Option>
            ))}
        </Select>
    );
};

Dropdown.canContinue = answer => {
    return !Boolean(answer && answer.choices && answer.choices.length);
}

export default Dropdown;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/Dropdown.js